export const RADIAL_CHART_OPTIONS = {
    chart: {
        type: 'radialBar',
    },
    colors: ['#36BFFA', '#C76EBA'],
    plotOptions: {
        radialBar: {
            startAngle: -90,
            endAngle: 90,
            track: {
                background: '#F9FAFB',
                startAngle: -90,
                endAngle: 90,
            },
            dataLabels: {
                show: true,
                name: {
                    show: true,
                    fontSize: '12px',
                    lineHeight: '18px',
                    fontWeight: 500,
                    color: '#667085',
                },
                value: {
                    show: true,
                    fontSize: '18px',
                    lineHeight: '28px',
                    fontWeight: 500,
                    color: '#101828',
                },
                total: {
                    show: false,
                  },
            },
        },
    },
    stroke: {
        lineCap: 'butt',
    },
    labels: ['Virtual', 'In Person'],
};

export const RADIAL_CHART_SERIES = [58.2, 41.8];

export const VIRTUAL_CHART_OPTIONS = {
    chart: {
        type: 'donut',
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    stroke: {
        show: false,
    },
    states: {
        hover: {
            filter: {
                type: 'darken',
                value: 0.50,
            }
        },
    },
    colors: ['#E0F2FE', '#7CD4FD', '#0BA5EC', '#026AA2', '#0B4A6F'],
    labels: ['Low', 'Medium', 'High', 'Very High'],
    legend: {
        show: false,
        position: 'bottom',
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        custom: function({series, seriesIndex, dataPointIndex, w}) {
            let seriesName = w.globals.seriesNames[seriesIndex];
            let value = series[seriesIndex];

            return `<div class="peer-to-peer-custom-tool-tip"> 
                    <p class="tool-tip-series-name">${seriesName}: ${value}%</p>                
                </div>`
        }        
    },
    responsive: [{
        breakpoint: 1400,
        options: {
            legend: {
                fontSize: '10px',
            },
        },
    }],
};

export const VIRTUAL_CHART_SERIES = [44, 55, 13, 33];

export const IN_PERSON_CHART_OPTIONS = {
    chart: {
        type: 'donut',
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    stroke: {
        show: false,
    },
    states: {
        hover: {
            filter: {
                type: 'darken',
                value: 0.50,
            }
        },
    },
    colors: ['#F3DBF1', '#DB97D2', '#AD509E', '#733567', '#3D1535'],
    labels: ['Low', 'Medium', 'High', 'Very High'],
    legend: {
        show: false,
        position: 'bottom',
    },
    dataLabels: {
        enabled: false,
    },
    tooltip: {
        custom: function({series, seriesIndex, dataPointIndex, w}) {
            let seriesName = w.globals.seriesNames[seriesIndex];
            let value = series[seriesIndex];

            return `<div class="peer-to-peer-custom-tool-tip "> 
                    <p class="tool-tip-series-name">${seriesName}: ${value}%</p>                
                </div>`
        }        
    },
    responsive: [{
        breakpoint: 1400,
        options: {
            legend: {
                fontSize: '10px',
            },
        },
    }],
};

export const IN_PERSON_CHART_SERIES = [44, 55, 13, 33];

export const HIGH_CHART_SEMI_DONUT_CHART = {
    chart: {
        type: 'pie',
        backgroundColor: null,
        plotBorderWidth: 0,
        plotShadow: false,
    },
    title: {
        text: null,
    },
    exporting: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        pie: {
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '75%'],
            dataLabels: {
                enabled: true,
                distance: -100,
                y: -5,
                format: '<b>{point.name}</b> <br /> {point.y}%',
                
            },
            point: {
                events: {
                    legendItemClick: function () {
                        return false; // Disable clicking on legend items
                    },
                },
            },
        },
    },
    series: [
        {

            data: [
                {
                    name: 'Virtual',
                    y: 58.2,
                    color: '#36BFFA',
                },
                {
                    name: 'In Person',
                    y: 41.8,
                    color: '#C76EBA',
                },
            ],
            size: '100%',
            innerSize: '75%',
            showInLegend: false,
            // dataLabels: {
            //     enabled: true,
            //     format: '<b>{point.name}</b>: {point.y}%',
            // },
        },
    ],
};

export const SEMI_DONUT_CHART_SERIES = [58.2, 41.8];

export const SEMI_DONUT_CHART_OPTIONS = {
    chart: {
        type: 'donut',
    },
    noData: {
        text: 'No data to display',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#000000',
          fontSize: '14px',
        }
    },
    colors:['#36BFFA', '#C76EBA'],
    labels: ['Branded', 'Unbranded'],
    legend: {
        show: false,
        position: 'bottom',
    },
    stroke: {
        show: false,
    },
    dataLabels: {
        enabled: false,
    },
    plotOptions: {
        pie: {
            startAngle: -90,
            endAngle: 90,
            offsetY: 10,
        },
    },
    grid: {
        padding: {
            bottom: -150,
        },
    },
    tooltip: {
        custom: function({series, seriesIndex, dataPointIndex, w}) {
            let seriesName = w.globals.seriesNames[seriesIndex];
            let value = series[seriesIndex];

            return `<div class="peer-to-peer-custom-tool-tip"> 
                    <p class="tool-tip-series-name">${seriesName}: ${value}%</p>                
                </div>`
        }        
    },
    responsive: [{
        breakpoint: 1400,
        options: {
            grid: {
                padding: {
                    bottom: -100,
                },  
            },
            legend: {
                fontSize: '10px',
            },
        },
    }]
};

